export default __webpack_public_path__ + "static/media/prodotti-img.424e37f1.png";